export enum AccountType {
  External = 'External',
  Internal = 'Internal',
}

export enum FirmType {
  External = AccountType.External,
  Internal = AccountType.Internal,
}

export enum AccountFirmRole {
  All = '',
  Compliance = 'Compliance',
  Normal = 'Normal',
}

export enum AccountGroupRole {
  All = '',
  Captain = 'Captain',
  Manager = 'Manager',
  Contributor = 'Contributor',
}

export enum AccountStatus {
  All = 'All',
  Active = 'Active',
  Inactive = 'Inactive',
  PendingConfirm = 'Pending Confirm',
}

export enum AccountInternalRole {
  All = 'All',
  Admin = 'Admin',
  Normal = 'Normal',
  SuperViewer = 'SuperViewer',
}

export enum FirmStatus {
  All = 'All',
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum TickerStatus {
  Active = 'active',
  Expired = 'expired',
}

export enum AccountCategory {
  All = '',
  Japan = 'Japan',
  Global = 'Global',
  GreaterChinaLowNet = 'Greater China - Low Net',
  GreaterChinaLongBias = 'Greater China - Long Bias',
  India = 'India',
  Korea = 'Korea',
}

export enum AccountRegion {
  Japan = 'Japan',
  Global = 'Global',
  GreaterChina = 'Greater China',
  India = 'India',
  Korea = 'Korea',
}

export enum AccountSubRegion {
  HknChina = 'HK/China',
  Taiwan = 'Taiwan',
}

export enum StatisticsAccountType {
  All = '',
  Trial = 'Trial',
  NotTrial = 'Not-Trial',
}

export enum IdeaState {
  PreLiquidate = 'PreLiquidate',
  Liquidate = 'Liquidate',
  Ignored = 'Ignored',
}
